export type FieldErrorResponse = {
  data?: {
    fields?: Record<string, string[]>;
    global?: string[];
  };
};

/**
 * Mensaje legible de un error de API. `lib/api.ts` ya vuelca en `message` el
 * primer error de campo de las respuestas 400, así que sirve para el snackbar.
 */
export function getErrorMessage(error: unknown): string | null {
  if (error instanceof Error && error.message) return error.message
  if (typeof error === 'object' && error !== null && 'message' in error) {
    const message = (error as { message?: unknown }).message
    if (typeof message === 'string' && message) return message
  }
  return null
}

export function getFieldErrors(error: unknown): Record<string, string> {
  const result: Record<string, string> = {}
  if (
    typeof error === 'object' &&
    error !== null &&
    'data' in error
  ) {
    const data = (error as FieldErrorResponse).data
    if (data) {
      if (data.fields) {
        for (const key in data.fields) {
          if (data.fields[key] && data.fields[key].length > 0) {
            result[key] = data.fields[key][0]
          }
        }
      }
      if (data.global && data.global.length > 0) {
        result._global = data.global[0]
      }
    }
  }
  return result
}
